import { IonLabel } from '@ionic/react';
import { ReactElement, useCallback, useState } from 'react';
import {
  Machine,
  useListMachinesByUserQuery,
} from '../../api/graphql/generated';
import i18n from '../../i18n';
import { useBeaconRouter } from '../../route/route.hooks';
import { IonItem } from '../ionic/IonItem';
import { ObjectList, RowRenderer } from '../object/object-list';
import { DateField } from '../ui/date-field';
import { ActiveFilterPopoverContent } from '../ui/searchbar/active-filter-popover-content';
import { SearchbarPopoverChildrenProps } from '../ui/searchbar/searchbar';

const TenantMachines = (): ReactElement => {
  const { builder } = useBeaconRouter();
  const [showActive, setShowActive] = useState<boolean>(true);

  const filterPopoverContent = (props: SearchbarPopoverChildrenProps) => {
    return (
      <ActiveFilterPopoverContent
        showActive={showActive}
        onActiveChange={(active) => {
          setShowActive(active);
          // eslint-disable-next-line react/prop-types
          props.close();
        }}
      />
    );
  };

  const rowRenderer = useCallback<RowRenderer<Machine>>(
    ({ item }) => {
      const endSlotClass = item.active ? 'ion-hide-sm-down' : undefined;
      const rightElement =
        item.active !== true ? (
          i18n.t('common:inactive')
        ) : (
          <DateField
            date={item.state?.updatedAt}
            fallback={i18n.t('common:last_activity_never')}
          />
        );
      let subtitle =
        item.state?.runtimeInfo?.serialNumber ?? i18n.t('common:unknown');
      if (item.demo) {
        subtitle += ` (${i18n.t('common:machine_demo')})`;
      }
      return (
        <IonItem
          className={item.active ? undefined : 'disabled-user'}
          key={item.id}
          routerLink={builder.getMachineRoute(item.teamId, item.id)}
        >
          <IonLabel>
            <h2>{item.name}</h2>
            <p>{subtitle}</p>
          </IonLabel>
          <IonLabel slot="end" className={endSlotClass}>
            <p>{rightElement}</p>
          </IonLabel>
        </IonItem>
      );
    },
    [builder]
  );

  return (
    <ObjectList
      query={{
        useQuery: useListMachinesByUserQuery,
        input: { active: showActive },
        queryOptions: {
          fetchPolicy: 'cache-and-network',
          nextFetchPolicy: 'cache-first',
        },
      }}
      filterPopoverContent={filterPopoverContent}
      showFilterIndicator={!showActive}
      noResults={i18n.t('common:no_results_found')}
      rowRenderer={rowRenderer}
    />
  );
};

export { TenantMachines };
